import { render } from "./ClientSelector.vue?vue&type=template&id=36ee420f"
import script from "./ClientSelector.vue?vue&type=script&lang=js"
export * from "./ClientSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__